import { render, staticRenderFns } from "./header.vue?vue&type=template&id=422a7037&scoped=true&"
var script = {}
import style0 from "./header.vue?vue&type=style&index=0&lang=css&"
import style1 from "./header.vue?vue&type=style&index=1&id=422a7037&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422a7037",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarItems } from 'vuetify/lib'
installComponents(component, {VSpacer,VToolbar,VToolbarItems})
